import store from '../../store/store';
export default function isInboxRuleOptionEditState() {
    return store.inboxRulesEditState.clauseMap.size > 0;
}
//# sourceMappingURL=isInboxRuleOptionEditState.js.map